import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorHandler from '../../controls/ErrorHandler';
const Dashboard = () => {
    return (<ErrorBoundary FallbackComponent={ErrorHandler}>      
    </ErrorBoundary>)
}

export default (Dashboard);
